import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { ValidationError } from "../../../app/slices/ValidationSlice";

interface InteractionErrorsViewProps {
  errors: ValidationError[] | string[];
  onErrorClick?: (nodeId?: string) => void;
}

export default function InteractionErrorsView(
  props: InteractionErrorsViewProps,
) {
  const { errors, onErrorClick } = { ...props };

  const handleErrorClick = (error: ValidationError | string) => {
    if (typeof error === "string") return;
    if (error.nodeId && onErrorClick) {
      onErrorClick(error.nodeId);
    }
  };

  const errorsMapped = errors.map((error, index) => {
    const message = typeof error === "string" ? error : error.message;
    const isClickable =
      typeof error !== "string" && error.nodeId && onErrorClick;

    return (
      <li
        key={index}
        className={`
          list-disc whitespace-normal break-words [overflow-wrap:anywhere]
          text-[13px] leading-5 text-creator-text-sub
          ${isClickable ? "cursor-pointer hover:text-creator-primary hover:underline" : ""}
        `}
        onClick={() => handleErrorClick(error)}
        title={isClickable ? "Click to focus node" : undefined}
      >
        {message}
      </li>
    );
  });

  return (
    <div
      className={
        "w-full min-w-0 max-w-full overflow-hidden p-2.5 flex flex-col gap-1.5 rounded-[5px] border border-solid border-creator-error bg-creator-error-washed"
      }
    >
      <div className={"text-creator-error flex items-center gap-1.5"}>
        <ErrorOutlineOutlinedIcon sx={{ fontSize: 16 }} color={"inherit"} />
        <div className={"text-[12px] font-semibold uppercase tracking-wide"}>
          Error
        </div>
      </div>
      <ul className={"min-w-0 max-w-full pl-4"}>{errorsMapped}</ul>
    </div>
  );
}
